import { Route, Routes } from 'react-router';
import SignIn from 'containers/pages/SignIn';
import MonthlyBalance from 'containers/pages/MonthlyBalance';
import OutgoAggregation from 'containers/pages/OutgoAggregation';
import MonthlyTotalAsset from 'containers/pages/MonthlyTotalAsset';
import EditMonthlyTotalAsset from 'containers/pages/EditMonthlyTotalAsset';
import ImportedOutgo from 'containers/pages/ImportedOutgo';
import Vehicles from 'containers/pages/FuelConsumption/Vehicles';
import RefuelHistories from 'containers/pages/FuelConsumption/RefuelHistories';
import NewVehicle from 'containers/pages/FuelConsumption/NewVehicle';
import Dashboard from './containers/pages/Dashboard';

const App = () => (
  <Routes>
    <Route path="/signin" element={<SignIn />} />
    <Route path="/monthly_balances/:year/:month" element={<MonthlyBalance />} />
    <Route path="/monthly_balances" element={<MonthlyBalance />} />
    <Route path="/imported_outgos" element={<ImportedOutgo />} />
    <Route path="/outgo_aggregations" element={<OutgoAggregation />} />
    <Route path="/monthly_total_assets" element={<MonthlyTotalAsset />} />
    <Route
      path="/monthly_total_assets/:id"
      element={<EditMonthlyTotalAsset />}
    />
    <Route path="/fuel_consumption/vehicles" element={<Vehicles />} />
    <Route path="/fuel_consumption/vehicles/new" element={<NewVehicle />} />
    <Route
      path="/fuel_consumption/vehicles/:vehicleId/refuel_histories"
      element={<RefuelHistories />}
    />
    <Route path="/" element={<Dashboard />} />
  </Routes>
);

export default App;
